import React, { useState } from 'react'

import { Button } from '~/client/src/shared/components/Button/Button'
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '~/client/src/shared/components/shadcn-ui/dialog'
import Localization from '~/client/src/shared/localization/LocalizationManager'

import BulkImportGuide from './BulkImportGuide'

interface IBulkAddHierarchyOptionsDialogProps {
  isOpen: boolean
  value: string
  onOpenChange: (open: boolean) => void
  onValueChange: (value: string) => void
  onAdd: () => void
}

const BulkAddHierarchyOptionsDialog: React.FC<
  IBulkAddHierarchyOptionsDialogProps
> = ({ isOpen, value, onOpenChange, onValueChange, onAdd }) => {
  const [isGuideOpen, setIsGuideOpen] = useState(false)

  const handleOpenChange = (open: boolean) => {
    if (!open) setIsGuideOpen(false)
    onOpenChange(open)
  }

  return (
    <Dialog open={isOpen} onOpenChange={handleOpenChange}>
      <DialogContent className="tw:max-w-xl tw:sm:max-w-xl">
        {isGuideOpen ? (
          <BulkImportGuide onBack={() => setIsGuideOpen(false)} />
        ) : (
          <>
            <DialogHeader>
              <DialogTitle className="tw:m-0">
                {Localization.translator.bulkAddOptions}
              </DialogTitle>
              <DialogDescription
                render={<ol />}
                className="tw:m-0 tw:list-inside tw:list-decimal tw:space-y-1 tw:ps-0"
              >
                <li>{Localization.translator.bulkAddOptionEnterEachLine}</li>
                <li>{Localization.translator.bulkAddOptionIndentToNest}</li>
                <li>
                  {Localization.translator.bulkAddOptionCopyFromExcel} (
                  <button
                    type="button"
                    onClick={() => setIsGuideOpen(true)}
                    className="tw:inline tw:cursor-pointer tw:appearance-none tw:border-0 tw:bg-transparent tw:p-0 tw:text-app-dense tw:text-primary tw:underline tw:underline-offset-3 tw:hover:text-foreground"
                  >
                    {Localization.translator.seeTips}
                  </button>
                  ).
                </li>
              </DialogDescription>
            </DialogHeader>
            <textarea
              value={value}
              placeholder={`Option 1\nOption 2\nOption 3\n→ Option 3.1\n→ → Option 3.1.1`}
              className="tw:min-h-64 tw:w-full tw:resize-y tw:rounded-lg tw:border tw:border-solid tw:border-input tw:bg-transparent tw:p-3 tw:text-body-md tw:text-foreground tw:outline-none tw:placeholder:text-muted-foreground tw:focus-visible:border-ring tw:focus-visible:ring-3 tw:focus-visible:ring-ring/50"
              onChange={(event: React.ChangeEvent<HTMLTextAreaElement>) =>
                onValueChange(event.target.value)
              }
            />
            <DialogFooter>
              <Button variant="outline" onClick={() => handleOpenChange(false)}>
                {Localization.translator.cancel}
              </Button>
              <Button onClick={onAdd}>
                {Localization.translator.addOptions}
              </Button>
            </DialogFooter>
          </>
        )}
      </DialogContent>
    </Dialog>
  )
}

export default BulkAddHierarchyOptionsDialog
